import { render, staticRenderFns } from "./ButtonsPisos.vue?vue&type=template&id=239484c6"
import script from "./ButtonsPisos.vue?vue&type=script&lang=js"
export * from "./ButtonsPisos.vue?vue&type=script&lang=js"
import style0 from "./ButtonsPisos.vue?vue&type=style&index=0&id=239484c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports